import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchases } from '../data/purchases';
const MINUTES = [2, 3, 5, 7, 8, 11, 14];

/**
 * Social-proof popup: rotates recent purchases of the digital book.
 */
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const showTimer = window.setTimeout(() => {
      setVisible(true);
      hideTimer = window.setTimeout(() => setVisible(false), 6000);
    }, 6000);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
    };
  }, [dismissed]);
  useEffect(() => {
    if (dismissed) return;
    const interval = window.setInterval(() => {
      setIndex(prev => (prev + 1) % purchases.length);
      setVisible(true);
      window.setTimeout(() => setVisible(false), 6000);
    }, 14000);
    return () => window.clearInterval(interval);
  }, [dismissed]);
  const purchase = purchases[index];
  const minutes = MINUTES[index % MINUTES.length];
  return <AnimatePresence data-id="element-39" data-mp="1fuhbugfbp6lr">
      {visible && !dismissed && <motion.div initial={{
      x: -40,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -40,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 28
    }} className="fixed bottom-24 left-3 z-50 w-[calc(100%-1.5rem)] max-w-[330px] rounded-2xl border border-navy-100 bg-white p-3 shadow-2xl shadow-navy-900/20 sm:bottom-28 sm:left-5" role="status" aria-live="polite" data-id="element-40" data-mp="1awzbvfjaa1pw">
          <div className="flex items-start gap-3" data-id="element-41" data-mp="s8asiy0g84g8">
            <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-green-100" data-id="element-42" data-mp="28joik2oxl2i3">
              <CheckCircle2Icon className="h-5 w-5 text-green-600" aria-hidden="true" data-id="element-43" data-mp="23kld4h51gu9l" />
            </div>
            <div className="min-w-0 flex-1" data-id="element-44" data-mp="2fno1haoghc05">
              <p className="text-[13px] font-bold leading-snug text-navy-900" data-id="element-45" data-mp="2fmmlcrsl1zbk">
                {purchase.name}
              </p>
              <p className="text-[12px] leading-snug text-navy-700/80" data-id="element-46" data-mp="2kniubjrskbnu">
                acaba de comprar{' '}
                <span className="font-semibold text-accent" data-id="element-47" data-mp="2pjhmlig8qdtj">
                  Ruta Hipotiroidismo™
                </span>
              </p>
              <p className="mt-1 text-[11px] font-medium text-navy-700/60" data-id="element-48" data-mp="1wwddb1a47dby">
                {purchase.location} · hace {minutes} min
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="-mr-1 -mt-1 rounded-full p-1 text-navy-400 transition-colors hover:bg-navy-50 hover:text-navy-700" data-id="element-49" data-mp="26mzliafi51km">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-50" data-mp="1e4kh6xzr1c00" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}